import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  Stack,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { USER_ROLES } from "../../utils/constants";

const DISCREPANCY_BADGE_LABELS = {
  date_mismatch: "Date mismatch",
  partially_filled: "Partial",
  out_of_range: "Out of range",
};

export const renderDiscrepancyBadges = (byType) => (
  <Stack direction="row" spacing={0.5} flexWrap="wrap">
    {Object.entries(byType || {})
      .filter(([, count]) => count > 0)
      .map(([type, count]) => (
        <Chip
          key={type}
          size="small"
          variant="outlined"
          label={`${DISCREPANCY_BADGE_LABELS[type] || type} ${count}`}
        />
      ))}
  </Stack>
);

const EcrfDiscrepancyPopUp = ({
  setEcrfDiscrepancyPopUp,
  ecrfDiscrepancies,
  trialId,
  trialStructure,
}) => {
  const navigate = useNavigate();

  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const isCro = user_data.role === USER_ROLES.CRO;

  const routeTo = (id) => {
    const page = trialStructure === "visit_based" ? "ecrf" : "visit_status";
    const link = "/patient/" + id + "/" + page + "?trial=" + trialId;

    const newTab = window.open(link, "_blank");
    if (newTab) {
      newTab.focus();
    } else {
      navigate(link);
    }
  };

  return (
    <Dialog
      open
      onClose={() => setEcrfDiscrepancyPopUp(false)}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle>
        <IconButton
          onClick={() => setEcrfDiscrepancyPopUp(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6" fontWeight="bold" textAlign="center" gutterBottom>
          Patients
        </Typography>
        <List disablePadding>
          {(ecrfDiscrepancies?.patients || []).map((patient) => (
            <ListItemButton
              key={patient.id}
              onClick={isCro ? undefined : () => routeTo(patient.id)}
              disabled={isCro}
              data-testid="discrepancy-patient-row"
              data-participant-id={patient.participant_id}
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Typography variant="body2" fontWeight={700} sx={{ width: 100, flexShrink: 0 }}>
                {patient?.participant_id || "-"}
              </Typography>
              <Box sx={{ flex: 1 }}>
                {renderDiscrepancyBadges({
                  date_mismatch: patient.date_mismatch,
                  partially_filled: patient.partially_filled,
                  out_of_range: patient.out_of_range,
                })}
              </Box>
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default EcrfDiscrepancyPopUp;
